module.exports = __webpack_public_path__ + "img/image28.fb35d889.png";